<template>
    <div>
        <div class="button noselect"
             v-on:click="clicked(hiddenKey,hiddenKey2)"
             v-on:keyup="onEnterKey"
             tabindex="0">
            <img src="@/assets/delete.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: "BBtnIconDelete",
        props: {
            imgSrc: String,
            btnTxt: String,
            clicked: Function,
            hiddenKey: Number,
            // 需要传两个值
            hiddenKey2: Number,
            lengthPx: Number,
            size: String,
        },
        data() {
            return {}
        },
        methods: {
            onEnterKey(event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    this.clicked(this.hiddenKey,this.hiddenKey2);
                }
            }
        },
    }
</script>

<style scoped>
    .button {
        display: flex;
        height: 38px;
        width: 38px;
        background: #F5365C;
        border-radius: 5px;
        color: #FEFEFE;
        justify-content: center;
        align-items: center;
        margin: 0 0.5em 0 0;
        cursor: pointer;
        font-size: 14px;
    }
    :focus {
        outline: none;
    }

    .button:hover,
    .button:focus {
        background: #FF4D62;
    }

    .button:active {
        background: #EC0130;
    }

    .button img {
        width: 19px;
        height: 19px;
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }
</style>